module.exports = __webpack_public_path__ + "static/media/logoWhite.1494d26b.svg";